// Don't use this static list — fetch from /api/coredata/nationalities/ instead.
// Kept only as an emergency fallback. The two values below collided on the
// same UUID, which is why this list is now considered deprecated.
export const NATIONALITIES = [];

export const GENDERS = [
  { label: "Male", value: "MALE" },
  { label: "Female", value: "FEMALE" },
];

// Indian states + union territories (alphabetised). Used by Player / Team /
// Stadium add forms for the state-level location picker. City / district is a
// freeform text field on the same schema — keeps tier-2/3 cities + non-listed
// districts valid for B2C scorers, which a static district list wouldn't.
export const INDIAN_STATES = [
  { label: "Andhra Pradesh", value: "Andhra Pradesh" },
  { label: "Arunachal Pradesh", value: "Arunachal Pradesh" },
  { label: "Assam", value: "Assam" },
  { label: "Bihar", value: "Bihar" },
  { label: "Chhattisgarh", value: "Chhattisgarh" },
  { label: "Goa", value: "Goa" },
  { label: "Gujarat", value: "Gujarat" },
  { label: "Haryana", value: "Haryana" },
  { label: "Himachal Pradesh", value: "Himachal Pradesh" },
  { label: "Jharkhand", value: "Jharkhand" },
  { label: "Karnataka", value: "Karnataka" },
  { label: "Kerala", value: "Kerala" },
  { label: "Madhya Pradesh", value: "Madhya Pradesh" },
  { label: "Maharashtra", value: "Maharashtra" },
  { label: "Manipur", value: "Manipur" },
  { label: "Meghalaya", value: "Meghalaya" },
  { label: "Mizoram", value: "Mizoram" },
  { label: "Nagaland", value: "Nagaland" },
  { label: "Odisha", value: "Odisha" },
  { label: "Punjab", value: "Punjab" },
  { label: "Rajasthan", value: "Rajasthan" },
  { label: "Sikkim", value: "Sikkim" },
  { label: "Tamil Nadu", value: "Tamil Nadu" },
  { label: "Telangana", value: "Telangana" },
  { label: "Tripura", value: "Tripura" },
  { label: "Uttar Pradesh", value: "Uttar Pradesh" },
  { label: "Uttarakhand", value: "Uttarakhand" },
  { label: "West Bengal", value: "West Bengal" },
  // Union Territories
  { label: "Andaman and Nicobar Islands", value: "Andaman and Nicobar Islands" },
  { label: "Chandigarh", value: "Chandigarh" },
  { label: "Dadra and Nagar Haveli and Daman and Diu", value: "Dadra and Nagar Haveli and Daman and Diu" },
  { label: "Delhi", value: "Delhi" },
  { label: "Jammu and Kashmir", value: "Jammu and Kashmir" },
  { label: "Ladakh", value: "Ladakh" },
  { label: "Lakshadweep", value: "Lakshadweep" },
  { label: "Puducherry", value: "Puducherry" },
];

// Don't use this static list — fetch from /api/matches/matchtypes/ instead so
// new types added on the backend (e.g. T10, The Hundred) appear automatically.
// Kept only for legacy code paths.
export const MATCH_TYPES = [
  { label: "T20",          value: "0f7bd534-3d4b-412b-a1de-d68adcb3468a" },
  { label: "ODI",          value: "46f78462-124c-48f9-915d-13f88e96eb13" },
  { label: "Test",         value: "649710f2-4bc8-4421-beb8-9f1e6683fbd4" },
  { label: "T10",          value: "d9dc9302-ce19-4c70-b6f6-5784ce64d39a" },
  { label: "T20 (BBL)",    value: "df70c809-ec2b-401a-a8e6-4bbd0f5af126" },
  { label: "T20 (IPL)",    value: "92aa4177-d409-4ee4-9a95-887235387eb1" },
  { label: "The Hundred",  value: "02e4a820-b63c-4e32-a5e5-e416c4c3b1d7" },
];

// Structured bowling styles — must match Player.BOWLING_STYLE_CHOICES on the
// backend (coredata/models.py). Empty value first so an unset player isn't
// forced into a code on first save.
export const BOWLING_STYLES = [
  { label: "Left arm fast (LAF)",           value: "LAF" },
  { label: "Right arm fast (RAF)",          value: "RAF" },
  { label: "Left arm medium fast (LAMF)",   value: "LAMF" },
  { label: "Right arm medium fast (RAMF)",  value: "RAMF" },
  { label: "Left arm medium (LAM)",         value: "LAM" },
  { label: "Right arm medium (RAM)",        value: "RAM" },
  { label: "Right arm off break (RAO)",     value: "RAO" },
  { label: "Left arm orthodox (LAO)",       value: "LAO" },
  { label: "Right arm wrist spin (RAW)",    value: "RAW" },
  { label: "Left arm wrist spin (LAW)",     value: "LAW" },
];

export const TEAM_TYPES = [
  { label: "International", value: "INTERNATIONAL" },
  { label: "Domestic", value: "DOMESTIC" },
];

export const TEAM_CATEGORIES = [
  { label: "Men", value: "MEN" },
  { label: "Women", value: "WOMEN" },
  { label: "U19", value: "U19" },
  { label: "U16", value: "U16" },
  { label: "Mixed", value: "MIXED" },
];

export const TIME_ZONES = [
  { label: "IST (Asia/Kolkata)", value: "Asia/Kolkata" },
  { label: "AEST (Australia/Sydney)", value: "Australia/Sydney" },
  { label: "GMT (Etc/UTC)", value: "Etc/UTC" },
  { label: "BST (Europe/London)", value: "Europe/London" },
];

export const MATCH_MODES = [
  { label: "ONLINE", value: "ONLINE" },
  { label: "OFFLINE", value: "OFFLINE" },
];

export const TOURNAMENT_TYPES = [
  { label: "International", value: "INTERNATIONAL" },
  { label: "Domestic",      value: "DOMESTIC" },
  { label: "League",        value: "LEAGUE" },
  { label: "School",        value: "SCHOOL" },
  { label: "Club",          value: "CLUB" },
  { label: "Local",         value: "LOCAL" },
];

export const SERIES_TYPES = [
  { label: "Bilateral", value: "BILATERAL" },
  { label: "Tri-Series", value: "TRI_SERIES" },
];

export const BATTING_HANDS = [
  { label: "Right Handed", value: "RIGHT" },
  { label: "Left Handed", value: "LEFT" },
];

export const BOWLING_HANDS = [
  { label: "Right Arm", value: "RIGHT" },
  { label: "Left Arm", value: "LEFT" },
];

export const PLAYER_ROLES = [
  { label: "Batsman", value: "BATTER" },
  { label: "Bowler", value: "BOWLER" },
  { label: "All Rounder", value: "ALL_ROUNDER" },
  { label: "Wicket Keeper", value: "WICKET_KEEPER" },
];

export const BOWLING_TYPES = [
  { label: "Fast", value: "PACE" },
  { label: "Medium", value: "MEDIUM" },
  { label: "Spin", value: "SPIN" },
];

export const BATTING_TYPES = [
  { label: "AGGRESSIVE", value: "AGGRESSIVE" },
  { label: "ANCHOR", value: "ANCHOR" },
  { label: "FINISHER", value: "FINISHER" },
];

export const ROLES = [
  { label: "Umpire", value: "UMPIRE" },
  { label: "Referee", value: "REFEREE"}
]